import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { Calendar } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
//local
import "./MyList.css";
import { MyText, MyButton, TextInput } from "../";
import { addCommas } from "../../utils";
import { Link } from "react-router-dom";
// import { apiAddress } from "../../utils";

const itemsTitle = [
  "شماره",
  "نام کاربر",
  "مبلغ",
  "نوع پرداخت",
  "وضعیت",
  "تاریخ ایجاد تراکنش",
  "عملیات",
];

const MyListPayment = ({
  data,
  token,
  pages,
  setPage,
  page,
  totalDocs,
  set_search_text,
  search_text,
  GetPayments_function,
  set_status,
  _status,
  set_start_date,
  start_date,
  set_end_date,
  end_date,
  selectedDayRange,
  setSelectedDayRange,
}) => {
  return (
    <>
      <div className="myList">
        <div style={{ width: "100%" }}>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <MyText color="#2d3ab5" size="1.2rem">
                جدول تراکنش ها
              </MyText>
            </div>
            <MyText color="black" size="1.2rem">
              تعداد تراکنش ها : {addCommas(totalDocs)}
            </MyText>
          </div>
          <div className="myList__header">
            <div className="myList__header--buttons">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginLeft: "1rem" }}>متن جست و جو :</div>
                <input
                  type="text"
                  value={search_text}
                  onChange={(e) => set_search_text(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "1rem" }}>تاریخ :</div>
                <DatePicker
                  value={selectedDayRange}
                  onChange={(e) => {
                    console.log(e);
                    const from = e.from;
                    const to = e.to;
                    if (from)
                      set_start_date(
                        moment(
                          String(
                            `${from.year}/${
                              String(from.month).length === 1
                                ? "0" + from.month
                                : from.month
                            }/${
                              String(from.day).length === 1
                                ? "0" + from.day
                                : from.day
                            }`
                          ),
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ).toISOString()
                      );
                    if (to)
                      set_end_date(
                        moment(
                          String(
                            `${to.year}/${
                              String(to.month).length === 1
                                ? "0" + to.month
                                : to.month
                            }/${
                              String(to.day).length === 1
                                ? "0" + to.day
                                : to.day
                            }`
                          ),
                          "jYYYY/jMM/jDD HH:mm:ss"
                        ).toISOString()
                      );
                    setSelectedDayRange(e);
                  }}
                  inputPlaceholder="انتخاب نمایید"
                  shouldHighlightWeekends
                  locale="fa" // add this
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: "2rem",
                  alignItems: "center",
                }}
              >
                <select
                  class="custom-select"
                  id="customSelect"
                  value={_status}
                  onChange={(e) => set_status(e.target.value)}
                >
                  <option selected value={null}>
                    انتخاب وضعیت پراخت
                  </option>

                  <option value={true}>موفق</option>
                  <option value={false}>ناموفق</option>
                </select>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-success "
              onClick={() => {
                setPage(1);
                GetPayments_function().then(() => null);
              }}
            >
              جست و جو
            </button>
          </div>
        </div>
        <div className="myList__itemsTitle">
          {itemsTitle.map((value) => (
            <div className="myList__itemsTitle--item">
              <MyText color="#50525c" size="1rem">
                {value}
              </MyText>
            </div>
          ))}
        </div>
        <div className="myList__itemsContainer">
          {data.map((item, index) => (
            <div className="myList__items">
              <div className="myList__item">
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {Number(index + 1) * Number(page)}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item.user_id.name}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {addCommas(item._price)} تومان
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item._type === "online" ? "آنلاین" : "کارت به کارت"}
                  </MyText>
                </div>
                <div className="myList__item">
                  <MyText color="#23242b" size="1rem">
                    {item._status === "paid"
                      ? "موفق"
                      : item._status === "waiting"
                      ? "در انتظار تایید"
                      : "ناموفق"}
                  </MyText>
                </div>
                <div className="myList__item" style={{ direction: "ltr" }}>
                  <MyText color="#23242b" size="1rem">
                    {moment(item.creation_date)
                      .locale("fa")
                      .format("YYYY/MM/DD, h:mm:ss a")}
                  </MyText>
                </div>
                <div className="myList__item">
                  <Link
                    to={{
                      pathname: "/dashboard/paymentDetails/" + item._id,
                      query: { data: item },
                    }}
                  >
                    <button
                      type="button"
                      class="btn btn-primary round mr-1 mb-1 btn-sm"
                    >
                      جزییات
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="myList__footer">
        <div className="myList__footerPagination">
          {page !== 1 ? (
            <div
              onClick={() => setPage(page - 1)}
              className="myList__footerPagination--item"
            >
              قبلی
              {/* <span className="icon-bell" /> */}
            </div>
          ) : null}
          {pages - 2 <= page + 1 ? (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          ) : null}
          <div
            onClick={() => setPage(page)}
            className="myList__footerPagination--item active"
          >
            <MyText marginTop="0.3rem">{page}</MyText>
          </div>
          {pages === page ? null : (
            <div
              className="myList__footerPagination--item"
              onClick={() => setPage(page + 1)}
            >
              <MyText marginTop="0.3rem">{page + 1}</MyText>
            </div>
          )}

          {pages - 2 <= page + 1 ? null : (
            <div className="myList__footerPagination--item">
              <MyText marginTop="0.3rem">...</MyText>
            </div>
          )}
          {pages - 1 <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages - 1)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages - 1}</MyText>
            </div>
          )}
          {pages <= page + 1 ? null : (
            <div
              onClick={() => setPage(pages)}
              className="myList__footerPagination--item"
            >
              <MyText marginTop="0.3rem">{pages}</MyText>
            </div>
          )}
          {pages === page ? null : (
            <div
              onClick={() => setPage(page + 1)}
              className="myList__footerPagination--item"
            >
              {/* <span className="icon-bell" /> */}
              بعدی
            </div>
          )}
        </div>
        <div className="myList__footerHelp">
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot" />
            <MyText color="#ffad2b" size="12px">
              نیاز به پیگیری
            </MyText>
          </div>
          <div className="myList__footerHelp--item">
            <div className="myList__footerHelp--itemDot green" />
            <MyText color="#37ac68" size="12px">
              پیگیری شده
            </MyText>
          </div>
        </div>
      </div>
    </>
  );
};

export { MyListPayment };
